import React from "react";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
var IconEmail = function IconEmail(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10.06v8.082c0 .512-.196.95-.59 1.313a2.01 2.01 0 0 1-1.414.545H4.004c-.55 0-1.022-.182-1.415-.545C2.197 19.09 2 18.654 2 18.142V10.06l10.02 4.12 9.98-4.12Zm0-1.252-9.98 4.162L2 8.808v-2.95c0-.511.197-.95.59-1.313A2.011 2.011 0 0 1 4.003 4h15.992c.55 0 1.022.182 1.415.545.393.364.589.802.589 1.314v2.95Z",
    fill: "#4585FF"
  }));
};
IconEmail.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { Container, Summary, Title, TitleAndSummaryContainer } from "./styles";
export const SummaryDisplay = () => {
  var _newsletterItemForDis;
  const {
    newsletterItemForDisplay
  } = useNewsletterContext();
  return /*#__PURE__*/React.createElement(Container, {
    "data-qa": "summary-display"
  }, /*#__PURE__*/React.createElement(TitleAndSummaryContainer, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(IconEmail, null), "NEWSLETTER"), /*#__PURE__*/React.createElement(Summary, null, newsletterItemForDisplay === null || newsletterItemForDisplay === void 0 || (_newsletterItemForDis = newsletterItemForDisplay.summary) === null || _newsletterItemForDis === void 0 ? void 0 : _newsletterItemForDis.text)));
};
SummaryDisplay.displayName = "SummaryDisplay";